import { useIonViewWillLeave, IonProgressBar, IonCardTitle, IonCardHeader, IonCardContent, IonRefresherContent, IonRefresher, IonGrid, IonRow, IonCol, IonToast, useIonViewWillEnter, IonIcon, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { hourglassOutline, copyOutline, helpCircleOutline } from "ionicons/icons";
import React, { useState, useEffect } from "react";
import { Clipboard } from '@capacitor/clipboard';
import { Browser } from '@capacitor/browser';

import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import HelpBut from "../components/HelpBut";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css';  

var refreshTimer : any;

const ShowAddress: React.FC = () => {
    const [address, setAddress] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [timer, setTimer] = useState(0);
    const [time_left, setTimeLeft] = useState(0);

    useIonViewWillEnter(() => {
        getData();
    });

    const copyAddress = async () => {
        await Clipboard.write({
            string: address
        });

        setShowToast(true);
    }

    useIonViewWillLeave(() => {
        clearInterval(refreshTimer);
    });

    const doRefresh = async (ev : any) => {
        await getData();
        ev.detail.complete();
    };

    const getData = async () => {

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("get_address", state);

        if (server.success)
        {
            setTimer(server.data.timer);
            setTimeLeft(server.data.time_left);
		    setAddress(server.data.address);
        }
	}

    const doTimer = () => {
        if (time_left > 0)
        {
            setTimeLeft(time_left - 1);
        }
    }

    useEffect(() => {
        refreshTimer = setTimeout(() => {
            doTimer();
        }, 1000);
    });

    const showHow = async () => {
        await Browser.open({ url: 'https://nwallet.me/d/help.php?d=cryptotopup' });
    }

    const needMoreTime = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("add_address_time", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
            getData();
    }

    return (
        <IonPage>
            <IonHeader>
            </IonHeader>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/token/wallet" ></IonBackButton>
                    </IonButtons>
                    <HelpBut topic="cryptotopup" />
                </IonToolbar>
                <IonToast
                    isOpen={showToast}
                    onDidDismiss={() => setShowToast(false)}
                    message={ GetStr(LANGUAGE.TXT_ADDRESS_COPIED) }
                    duration={1000}
                />
                <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-padding" size-md="10" size-lg="8" size-xl="6" size="12">
                            { GetStr(LANGUAGE.TXT_ADDRESS_INFO) }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonCard className="flat-card">
                                <IonCardHeader>
                                    <IonCardTitle>{ time_left > 0 ? address : "[address expired]" }</IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <IonButton className="main-but" color="primary" expand="block" onClick={copyAddress} >
                                        <IonIcon slot="start" icon={copyOutline}/>
                                        { GetStr(LANGUAGE.TXT_ADDRESS_DOCOPY) }
                                    </IonButton>
                                    <IonButton className="ion-margin-top main-but" color="secondary" expand="block" onClick={showHow} >
                                        <IonIcon slot="start" icon={helpCircleOutline}/>
                                        { GetStr(LANGUAGE.TXT_ADDRESS_SHOWHOW) }
                                    </IonButton>
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonCard className="flat-card">
                                <IonCardContent>
                                    <div>{GetStr(LANGUAGE.TXT_ADD_TIME_INFO_1)}{time_left}{GetStr(LANGUAGE.TXT_ADD_TIME_INFO_2)}</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={hourglassOutline} size='large' slot="start" />
                                        <IonLabel>{GetStr(LANGUAGE.TXT_ADD_TIMELEFT)}{time_left}</IonLabel>
                                    </IonItem>
                                </IonCardContent>
                                <IonProgressBar value={ time_left / timer}></IonProgressBar>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );

};

export default ShowAddress;